<template>
	<div>
		<div class="flex justify-between items-end mb-14-c">
			<div>
				<ReportsNav />
			</div>
		</div>

		<div class="row text-right mb-2">
			<div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto text-left">
				<FilterClient class="d-inline-block" filterId="accountBalanceHistory"
					@changeFilterClient="changeFilterClientAccountBalanceHistory" :clients_prop="listClients">
				</FilterClient>
			</div>
		</div>

		<div v-if="$store.getters.paymentMethod == 'rped' && (accountLevel == 'client' || accountLevel == 'lp')">
			<div class="card">
				<div class="card-header">
					<!-- <h5 v-if="selectedClientAccountBalanceHistory != 'all'">CURRENT BALANCES ({{selectedClientAccountBalanceHistory.hin_abx}} - {{selectedClientAccountBalanceHistory.personal_data[0].full_name}})</h5>
								<h5 v-else> CURRENT BALANCES (ALL) </h5> -->
					<h5> CURRENT BALANCES (ALL) </h5>

					<div class="row">
						<div class="col-sm-12 col-md-4 text-left">
							<dl class="row text-left">
								<dt class="col-7">Available Trade Balance</dt>
								<dd class="col-5">: {{ currencySymbol }}
									{{ numberFormatExtend(Number(availableTradeBalance).toFixed(2)) }}</dd>

								<dt class="col-7">Account Balance</dt>
								<dd class="col-5">: {{ currencySymbol }} {{ numberFormatExtend((isNaN(accountBalance)) ? 0 :
									Number(accountBalance).toFixed(2)) }}</dd>

								<dt class="col-7">Reserved Balance</dt>
								<dd class="col-5">: {{ currencySymbol }} {{ numberFormatExtend(Number(reservedBalance).toFixed(2))
								}}
								</dd>
							</dl>
						</div>
						<div class="col-sm-12 col-md-4">
							<dl class="row text-left">
								<dt class="col-7">Credit Limit</dt>
								<dd class="col-5">: {{ currencySymbol }} {{
									numberFormatExtend(currentBalance.creditLimit.toFixed(2)) }}
								</dd>

								<dt class="col-7">Available Credit</dt>
								<dd class="col-5">: {{ currencySymbol }}
									{{ numberFormatExtend(currentBalance.availableCredit.toFixed(2)) }}</dd>
							</dl>
						</div>
						<div class="col-sm-12 col-md-4">
							<dl class="row text-left">
								<dt class="col-7">Settlement Owning</dt>
								<dd class="col-5">: {{ currencySymbol }}
									{{ numberFormatExtend(currentBalance.settlementOwning.toFixed(2)) }}</dd>
							</dl>
						</div>
					</div>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-sm-12 col-md-4">
							<p class="lead"><small>Available Trade Balance = Account Balance - Reserved Balance + Credit
									Limit</small></p>
						</div>
						<div class="col-sm-12 col-md-4">
							<p class="lead"><small>Available Credit = Credit Limit - Settlement Owning - Credit Reserved for
									Trades</small></p>
						</div>
						<div class="col-sm-12 col-md-4">
							<p class="lead"><small>Reserved Balance = Total Limit Price + Execution Fee + Tax + {{
								$store.state.fxBuffer * 100 }}% Total Limit
									Price (FX Buffer) + Total Transactions On Process</small></p>
						</div>
					</div>

					<div class="row">
					</div>
				</div>
			</div>
		</div>

		<div v-if="$store.getters.paymentMethod == 'rped'" class="">
			<Pagination2 :totalData_prop="totalAccountBalanceHistory" @changePage="setAccountBalanceHistory">
			</Pagination2>
		</div>

		<div v-if="$store.getters.paymentMethod == 'rped'" class="table-responsive p-0">
			<table class="table table--report text-nowrap">
				<thead style="background-color: #0f0f17">
					<tr class="text-center">
						<th>DATE</th>
						<th>EFFECTIVE ACCOUNT ID</th>
						<th>ACCOUNT</th>
						<th>TRANSACTION ID</th>
						<th>TRANSACTION</th>
						<th>AMOUNT</th>
						<!-- <th>ACCOUNT BALANCE</th> -->
					</tr>
				</thead>
				<tbody>
					<template v-if="accountBalanceHistoriesStatus != 'loading'">
						<tr v-for="accountBalanceHistory in accountBalanceHistories"
							v-bind:key="'accountBalanceHistory' + accountBalanceHistory.transactionId">
							<td class="text-center">{{ accountBalanceHistory.date }}</td>
							<td class="text-center">{{ accountBalanceHistory.effectiveAccountId }}</td>
							<td class="text-center">{{ accountBalanceHistory.account }}</td>
							<td class="text-center">{{ accountBalanceHistory.transactionId }}</td>
							<td class="text-center">{{ accountBalanceHistory.transaction }}</td>
							<td v-if="currency == 'usd'" class="text-right">{{ numberFormatExtend(accountBalanceHistory.amount) }}
							</td>
							<td v-else class="text-right">{{ numberFormatExtend(accountBalanceHistory.amountIdr) }}</td>
						</tr>
						<tr v-if="accountBalanceHistories.length < 1">
							<td colspan="7" class="text-center">No data available in table</td>
						</tr>
					</template>
					<template v-else>
						<tr>
							<td class="text-center" colspan="7">
								<Loader size_prop="10em"></Loader>
							</td>
						</tr>
					</template>
				</tbody>
				<tfoot>

				</tfoot>
			</table>
		</div>

		<!-- Payment Method Gopay -->
		<div v-if="$store.getters.paymentMethod == 'gopay'" class="flex gap-3">
			<div class="w-217">
				<div class="text-white text-sm bg-grey-1 rounded-lg mb-6 p-6">
					<div class="mb-3">
						<img :src="`${publicPath}assets/img/logo-gopay-2.jpg`" class="rounded-sm h-6 mr-2"></img>
						<span>GoPay</span>
					</div>

					<div class="mb-3">
						<div class="flex items-center gap-2 text-xs opacity-85">
							<div v-if="showBalance" class="text-1.5xl font-bold">
								{{ currencySymbol }} {{ accountBalanceShown }}
							</div>
							<div v-else class="text-1.5xl font-bold">
								{{ currencySymbol }} &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>

							<div class="bg-white rounded-full p-1 cursor-pointer" @click="toggleSaldo()">
								<IconEyeClose v-if="!showBalance" width="1rem" height="1rem" :color_prop="hexColorTheme"></IconEyeClose>
								<IconEyeOpen v-else width="1rem" height="1rem" :color_prop="hexColorTheme"> </IconEyeOpen>
							</div>
						</div>
					</div>

					<div class="text-grey">
						{{ $store.getters.username }} / +{{ $store.getters.getPhoneNumber }}
					</div>
				</div>

				<div class="">
					<table class="w-full text-center text-white text-sm">
						<thead>
							<tr class="bg-grey-1 bg-clip-padding border-0 border-solid border-b-2 border-b-transparent">
								<th class="font-medium px-2.5 py-5">Order Direction</th>
								<th class="font-medium px-2.5 py-5">Date</th>
								<th class="font-medium px-2.5 py-5">Transaction ID</th>
								<th class="font-medium px-2.5 py-5">Total</th>
							</tr>
						</thead>
						<tbody class="bg-grey-1">
							<template v-if="accountBalanceHistoriesStatus == 'loading'">
								<tr>
									<td class="text-center p-4" colspan="7">
										<Loader size_prop="10em"></Loader>
									</td>
								</tr>
							</template>

							<template v-else-if="accountBalanceHistories.length < 1">
								<tr>
									<td colspan="7" class="text-center p-5">No data available in table</td>
								</tr>
							</template>

							<template v-else>
								<tr v-for="accountBalanceHistory in accountBalanceHistories" class=""
									v-bind:key="'accountBalanceHistory' + accountBalanceHistory.transactionId">
									<td
										:class="`text-center ${directionShown(accountBalanceHistory.description) == 'Beli' ? 'text-success' : 'text-danger'} p-4`">
										{{ directionShown(accountBalanceHistory.description) }}
									</td>
									<td class="text-center p-4">{{ accountBalanceHistory.date }}</td>
									<td class="text-center p-4">{{ accountBalanceHistory.transactionId }}</td>
									<td class="text-center p-4">
										{{ currencySymbol }}
										{{ currency == 'usd'
											? numberFormatExtend(accountBalanceHistory.amount)
											: numberFormatExtend(accountBalanceHistory.amountIdr)
										}}
									</td>
								</tr>
							</template>

						</tbody>
					</table>
				</div>
			</div>

			<div class="text-white text-sm bg-grey-1 rounded-lg h-fit p-6">
				<div class="font-bold mb-6">Unused Buffer</div>
				<div class="text-xs mb-6">Below is your Unused Buffer balance (fee buffer that was not used after the transaction).</div>
				<div class="text-1.5xl font-bold mb-3">
					Rp{{ unusedBuffer }}
				</div>
				<!-- <div class="text-xs text-theme cursor-pointer">Ajukan Penarikan</div> -->
			</div>
		</div>

	</div>
</template>

<script>
import axios from '@/api/axios.js'
import { Decimal } from 'decimal.js'

import ReportsNav from '../ReportsNav.vue'
import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'
import FilterClient from '@/components/FilterClient.vue'
import IconEyeClose from '../../icons/IconEyeClose.vue'
import IconEyeOpen from '../../icons/IconEyeOpen.vue'

import Utils from '../../../utils'

export default {
	name: 'AccountBalance',
	components: {
		ReportsNav,
		Pagination2,
		Loader,
		FilterClient,
		IconEyeClose,
		IconEyeOpen
	},
	data() {
		return {
			publicPath: process.env.BASE_URL,
			hexColorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),

			listClients: [],

			selectedClientAccountBalanceHistory: 'all',

			accountBalanceHistories: [],
			accountBalanceHistoriesStatus: 'idle',
			currentBalance: {
				availableTradeBalance: 0,
				accountBalance: 0,
				reservedBalance: 0,
				creditLimit: 0,
				availableCredit: 0,
				settlementOwning: 0
			},
			totalAccountBalanceHistory: 1,
			getAccountBalanceHistoryController: null,
			cancelTokenApiGetAccountBalanceHistory: '',
			cancelTokenApiGetHinAccountBalanceHistory: '',

			showBalance: true,

			unusedBuffer: '-',
		}
	},

	computed: {
		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		tabActive() {
			return this.$store.state.reportToShow
		},

		currency() {
			return this.$store.state.currency
		},

		hubsTemp() {
			return this.$store.state.hubs
		},

		contractsTemp() {
			return this.$store.state.contracts
		},

		products() {
			return this.$store.getters.PRODUCTS
		},

		currencySymbol() {
			if (this.currency == 'idr') {
				return 'Rp '
			} else {
				return '$'
			}
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		streamingRateBuy() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamBuy
			} else {
				return 1
			}
		},

		availableTradeBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.available_trade_bal
			} else {
				return this.$store.state.balances.available_trade_bal_usd
			}
		},
		accountBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.rdk_balance
			} else {
				return this.$store.state.balances.account_bal
			}
		},
		accountBalanceShown() {
			return Utils.currencyFormat(this.accountBalance, this.currency)
		},

		reservedBalance() {
			if (this.currency == 'idr') {
				if (this.accountLevel == 'client') {
					return this.$store.state.reservedBalanceIdr
				} else {
					return Number(Decimal.mul(this.$store.state.reservedBalanceUsd, this.streamingRateBuy))
				}
			} else {
				return this.$store.state.reservedBalanceUsd
			}
		},
	},

	watch: {
	},

	created() {
		const firstCall = setInterval(() => {
			if (this.products && this.contractsTemp && this.accountLevel && this.hubsTemp) {
				if (this.accountLevel != 'client' && this.accountLevel != 'lp') {
					if (this.listClients.length <= 0) {
						return
					}
				}

				clearInterval(firstCall)

				this.setAccountBalanceHistory()
			}
		}, 1000)

		if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
			this.setListClients()
		}

		this.setUnusedBuffer()
	},

	methods: {
		setAccountBalanceHistory(skip = 0, limit = 10) {
			if (this.getAccountBalanceHistoryController) {
				this.getAccountBalanceHistoryController.abort() // Cancel any ongoing request before starting a new one
			}
			this.getAccountBalanceHistoryController = new AbortController()

			this.accountBalanceHistoriesStatus = 'loading'


			let urlApi = ''
			let hin = ''
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
				if (this.selectedClientAccountBalanceHistory == 'all') {
					urlApi = '/v2/rrs/specific/balance_history?offset=' + skip + '&limit=' + limit
				} else {
					console.log('FILTER CLIENT', this.selectedClientAccountBalanceHistory)
					urlApi = '/v2/rrs/specific/balance_history?offset=' + skip + '&limit=' + limit + '&hin=' + this.selectedClientAccountBalanceHistory.trade_account.hin + '&accountId=' + this.selectedClientAccountBalanceHistory.trade_account.account_id
				}
			} else if (this.accountLevel == 'lp') {
				urlApi = '/v2/igx/market-maker/balance_history?offset=' + skip + '&limit=' + limit
			} else {
				urlApi = '/v2/igx/balance_history?offset=' + skip + '&limit=' + limit
			}

			axios.post(urlApi, {
				user_id: (this.selectedClientAccountBalanceHistory == 'all') ? this.$store.state.userId : ''
			}, {
				signal: this.getAccountBalanceHistoryController.signal
			}).then(response => {
				this.accountBalanceHistories = []
				this.currentBalance = {
					availableTradeBalance: 0,
					accountBalance: 0,
					reservedBalance: 0,
					creditLimit: 0,
					availableCredit: 0,
					settlementOwning: 0
				}

				this.totalAccountBalanceHistory = response.data.data.count

				let balanceHistories = response.data.data.body

				if (balanceHistories.length < 1) {
					this.accountBalanceHistoriesStatus = 'success'
				}

				let indexAccountBalanceHistory = 0


				balanceHistories.forEach((balanceHistory) => {
					let dateTemp = new Date(balanceHistory.attributes.createdAt)

					// Format: 1 Desember 2025 | 14.05
					let date = {
						date: dateTemp.getDate(),
						month: dateTemp.toLocaleString('default', { month: 'long' }),
						year: dateTemp.getFullYear(),
						hours: dateTemp.getHours(),
						minutes: dateTemp.getMinutes()
					}

					//
					if (this.accountLevel != 'ib' && this.accountLevel != 'fm') {
						if (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' || balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal') {
							return
						}
					} else if ((balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' && balanceHistory.attributes.amount <= 0) || (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal' && balanceHistory.attributes.amount >= 0)) {
						return
					}

					const rate = balanceHistory.attributes.rate || this.streamingRate.streamSell

					let account = ''
					if (this.accountLevel == 'fm') {
						hin = balanceHistory.attributes.hin
						account = balanceHistory.attributes.fullname
					} else {
						hin = this.$store.getters.getHin
						account = this.$store.getters.getFirstName
					}

					this.$set(this.accountBalanceHistories, indexAccountBalanceHistory, {
						date: `${date.date} ${date.month} ${date.year} | ${date.hours}:${date.minutes}`,
						effectiveAccountId: hin || '-',
						account: account || '-',
						transactionId: balanceHistory.id,
						transaction: balanceHistory.attributes.transactionTypeId,
						amount: balanceHistory.attributes.amount,
						amountIdr: Decimal.mul(balanceHistory.attributes.amount, rate).toNumber(),
						accountBalance: balanceHistory.attributes.total,
						description: balanceHistory.attributes.description
					})

					indexAccountBalanceHistory++

				})

				let creditLimit = 0
				let settlementOwning = 0
				let availableCredit = this.currentBalance.creditLimit - this.currentBalance.settlementOwning

				if (this.currency == 'idr') {
					this.currentBalance.creditLimit = creditLimit * this.streamingRate.streamBuy
					this.currentBalance.settlementOwning = settlementOwning * this.streamingRate.streamBuy
					this.currentBalance.availableCredit = availableCredit * this.streamingRate.streamBuy
				} else {
					this.currentBalance.creditLimit = creditLimit
					this.currentBalance.settlementOwning = settlementOwning
					this.currentBalance.availableCredit = availableCredit
				}

				this.accountBalanceHistoriesStatus = 'success'
				console.log('berhasil balance history', response)
			}).catch(error => {
				this.accountBalanceHistoriesStatus = 'idle'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal balance history', error)
			})
		},

		directionShown(description) {
			return description.toLowerCase() == 'trade buy' ? 'Beli' : 'Jual'
		},

		changeFilterClientAccountBalanceHistory(clientData) {
			this.selectedClientAccountBalanceHistory = clientData
			this.setAccountBalanceHistory()
		},

		setListClients() {
			let urlApi = ''
			if (this.accountLevel == 'ib') {
				urlApi = '/v2/rrs/ib/list/client'
			} else if (this.accountLevel == 'fm') {
				urlApi = '/v2/rrs/fm/list/branch'
			} else {
				urlApi = '/v2/rrs/ccp/list/branch'
			}

			axios.post(urlApi, {
				user_id: this.$store.state.userId
			}).then(response => {
				this.listClients = response.data.data.body
				console.log('Berhasil get list clients for ' + this.accountLevel, response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log("Gagal get list clients for " + this.accountLevel, error.config)
			})
		},

		toggleSaldo() {
			this.showBalance = !this.showBalance
		},

		async setUnusedBuffer() {
			const response = await axios.post('/v2/igx/buffer', {
				user_id: this.$store.state.userId
			})

			this.unusedBuffer = Utils.currencyFormat(response.data.data.body.available_idr, this.currency)
		},
	}
}
</script>

<style scoped>
table {
	clip-path: inset(0 round 10px);
}
</style>